import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getMessaging, getToken, onMessage, isSupported } from 'firebase/messaging';

// Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// VAPID key for web push (from Firebase Console → Project Settings → Cloud Messaging → Web Push Certificates)
export const VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY;

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

/**
 * Firebase Cloud Messaging.
 *
 * Messaging is unsupported in some browsers — iOS Safari outside a home-screen
 * web app, a private window, anything without IndexedDB — and getMessaging()
 * throws there, so isSupported() is asked first. That check is asynchronous,
 * which is why what is exported is the promise: whoever needs messaging awaits
 * it rather than reading a variable that is still null on the first render.
 *
 * `messaging` is still exported for anything that only has to know whether it
 * ended up available; it is null until the promise settles.
 */
let messaging = null;

export const messagingReady = isSupported()
  .then((supported) => {
    messaging = supported ? getMessaging(app) : null;
    if (!supported) console.warn('Firebase Messaging is not supported in this browser');
    return messaging;
  })
  .catch((err) => {
    console.warn('Firebase Messaging not available:', err.message);
    return null;
  });

export { messaging, getToken, onMessage };

// Enable development mode for testing
// This allows the use of test phone numbers
if (process.env.NODE_ENV === 'development') {
  console.log('Firebase initialized in development mode');
}

export default app;
